import { Page, DatePicker, FormGroup as UpdateFormGroup } from 'components/common';
import React, { useState, useEffect, useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { NotificationManager } from 'react-notifications';
import { Button, Table, Input as UpdateInput, Label } from 'reactstrap';
import BackButton from 'components/refactoring/BackButton';
import { useOrganisationContext, useUserContext } from "hooks";
import { ApiClient, } from "services";
import { Control, LocalForm } from 'react-redux-form';
import {  formatNumber, handleFilesCountUpdate } from 'services/util';
import {
  useForm,
  FormProvider,
  useFieldArray,
  useWatch,
} from "react-hook-form";
import {
  FormGroup,
  Input,
} from "components/react-hook-form";
import InputFilesForm from 'components/common/InputFilesForm';

const AddMasterFiles = ({ t, match }) => {

  const { selectedOrganisation } = useOrganisationContext();
  const { user } = useUserContext();
  const client = ApiClient();
  const year_id = match.params?.id
  const master_file_id = match.params?.master_file_id;
  const auditor_permission = useMemo(() => {
    return user?.permissions?.includes("access_audit_report");;
  }, [user?.permissions]);

  const [dateRange, setDateRange] = useState();

  const [masterFilesList, setMasterFilesList] = useState([
    {
      "id": 1,
      "name": t("Memorandum of Association"),
    },
    {
      "id": 2,
      "name": t("Commercial Register"),
    },
    {
      "id": 3,
      "name": t("Angel identity"),
    },
    {
      "id": 4,
      "name": t("Municipal License"),
    },
    {
      "id": 5,
      "name": t("Zakat certificate"),
    },
    {
      "id": 6,
      "name": t("Tax certificate"),
    },
    {
      "id": 7,
      "name": t("Insurance certificate"),
    },
    {
      "id": 8,
      "name": t("Chamber of Commerce certificate"),
    },
    {
      "id": 9,
      "name": t("Saudization certificate"),
    },
    {
      "id": 10,
      "name": t("Engagement letter"),
    }
  ]); 

  const methods = useForm({
    mode: "onBlur",
    defaultValues: {
      checkbox: false,
    }
  });
  const { reset, control, setValue, handleSubmit, watch, getValues } = methods;


  const { fields, remove, append } = useFieldArray({
    control,
    name: "account_file",
    keyName: "key",
  });
  const count_progress = useWatch({
    control,
    name: "account_file",
  })

  const [uploadedFilesCount, setUploadedFilesCount] = useState([]);

const progress = useMemo(
  () => (formatNumber((count_progress?.filter(item => item?.audit_requirements_account.length > 0 && item?.is_required)?.length / count_progress?.length) * 100, "0.0")) || 0,
  [count_progress]
);


useEffect(() => {
  fetchData();
  addMasterFilesList();
  fetchAllFilesData();
}, []);

const addMasterFilesList = () => {
  masterFilesList?.forEach((file) => {
    append({
      id: file?.id,
      file_name: file.name,
      is_required: false,
      uploaded: false,
      upload_date: '',
      uploaded_by: '',
      upload_file: null,
      user: "",
    });
  });
};

let totalLength = masterFilesList?.length;
let new_obj = {};
  let key = "id";
  let value = "name";

  const addRow = () => {
      append({
        id: totalLength + 1,
        file_name: "",
        is_required: false,
        uploaded: false,
        upload_date: '',
        uploaded_by: '',
        upload_file: null,
        user: "",
      });
      new_obj[key] = totalLength + 1;
      new_obj[value] = " ";
      masterFilesList.push(new_obj);

  };

  const fetchData = async () => {

    try {
      const dateRange = await client.get(`/audit_reports/${selectedOrganisation.id}/date_range/${year_id}`);
      setDateRange(dateRange.data);
    } catch (error) {
      NotificationManager.error(t("Error fetching data range"));
    }
  };

  const fetchAllFilesData = async () => {
    let files_data = {}
    let updated_data = {
      account_file: []
    }

    try {
      if (master_file_id !== "new"){
      files_data = await client.get(`/audit_reports/${selectedOrganisation.id}/master_files/${year_id}`);
    
      files_data.data?.account_file.map(master_file => {
        updated_data.account_file.push({
          ...master_file,
          updated_at: files_data?.data?.updated_at
        });
      })
    reset({...files_data.data, ...updated_data});
  }
  
    } catch (error) {
      NotificationManager.error(t("Error fetching master files"));
    }
  };

  const handleUpdateDateRange = async (values) => {
    const payload = {
      start_date: values.start_date,
      deadline: values.deadline,
      selected_year: year_id
    };

    try {
      const response = await client.put(`/audit_reports/${selectedOrganisation.id}/date_range/${year_id}/update_date_range`, payload);
      NotificationManager.success(t("Data submitted successfully"));
    } catch (error) {
      NotificationManager.error(t("Error submitting data"));
    }
  };

  const handleMasterSubmit = async (values) => {
    const payload = {
      progress: progress,
      master_files: year_id,
      account_file: values?.account_file

    };
      try {
          const response = await client.post(`/audit_reports/${selectedOrganisation.id}/master_files/${year_id}/create_master_files`, payload);
          const id = response?.data?.id
          NotificationManager.success(t("Master files submitted successfully"));
          window.location.replace(`/reports/audit_reports/master_file/${year_id}/${id}`);
      } catch (error) {
          NotificationManager.error(error?.response?.data?.error || t("Something went wrong"));
      }
  };

  return (
    <Page title={t("Add Master Files")}>
        <div className='d-flex justify-content-between align-items-center'>
            <BackButton/>
        </div>
      <div>
        {dateRange &&
        <>
        <LocalForm initialState={dateRange} onSubmit={handleUpdateDateRange}>
        <div className='d-flex justify-content-start mr-3'>
              <UpdateFormGroup label="Company Name" className="mr-3">
                <Control.text
                  model=".connectedsation"
                  className="form-control"
                  style={{ backgroundColor: '#F4F7FE' }}
                  readOnly
                  defaultValue={selectedOrganisation?.name}
                />
              </UpdateFormGroup>
              <UpdateFormGroup label="Audit start date" className="mr-3">
                <DatePicker
                  type="date"
                  className="form-control"
                  model=".start_date"
                  placeholder="Start Date"
                  disabled={auditor_permission === false}
                />
              </UpdateFormGroup>
              <UpdateFormGroup label="Deadline" className="mr-3">
                <DatePicker
                  type="date"
                  className="form-control"
                  model=".deadline"
                  placeholder="Deadline"
                  disabled={auditor_permission === false}
                />
              </UpdateFormGroup>
              <UpdateFormGroup label="&nbsp;" className="mr-3">
                <Button disabled={auditor_permission === false} color="primary" type="submit"><Trans>Save</Trans></Button>
              </UpdateFormGroup>
            </div>
        </LocalForm>
        <div className='my-2 d-flex justify-content-start align-items-center'>
          <div className='mt-2'>
            <Label><strong><Trans>Audit period end date</Trans></strong></Label>
          </div>
          <div className='ml-2'> 
            {dateRange?.end_date}
          </div>
      </div>
      </>
        }
        {progress > 0 ? (
          <div className="progress my-3 h-50">
            <div className="progress-bar h-50  progress-bg-clr" role="progressbar" style={{ width: `${progress}%`}}>
              {progress}%
            </div>
          </div>
        ):
        <div className="progress my-3 h-50">
            <div className="progress-bar h-50  progress-bg-clr" role="progressbar">
              {0}%
            </div>
          </div>
        }
        <FormProvider {...methods}>
        <Table>
            <thead>
                <tr>
                    <th></th>
                    <th className="text-center"><Trans>File name</Trans></th>
                    <th className="text-center"><Trans>Valid</Trans></th>
                    <th className="text-center"><Trans>Upload</Trans></th>
                    <th className="text-center"><Trans>Actions</Trans></th>
                    <th className="text-right" />
                </tr>
            </thead>
            <tbody>
                {fields.map((row, index) => {
                  const n = (v) => `account_file.${index}.${v}`;
                    return (
                      <tr key={row?.id}>
                        <td scope="row">
                          <Input
                            type="hidden"
                            name={n("id")}
                            value={row?.id || ""}	
                        />
                        </td>
                        <td className="text-center">
                        <Input
                            type="text"
                            className="form-control"
                            name={n("file_name")}
                            placeholder="File Name"
                        />
                        </td>
                        <td className="text-center">
                          <FormGroup className="d-flex justify-content-center align-items-center">
                            <Input
                              type='checkbox'
                              name={n("is_required")}
                              checked={getValues(n("is_required"))}
                              disabled={auditor_permission === false}
                            />
                          </FormGroup>
                        </td>
                        <td className="text-center">
                        <FormGroup>
                          <InputFilesForm t={t} getData={getValues} name={n(`audit_requirements_account`)} setValue={setValue} indx = {index} control ={ control } auditor_permission={auditor_permission} onFilesCountUpdate={(count) => handleFilesCountUpdate(count, setUploadedFilesCount, index)} uploadedFilesCount={uploadedFilesCount[index] || 0}></InputFilesForm>
                        </FormGroup>
                          
                        </td>
                        <td className="text-center">
                            <div className="d-flex justify-content-center align-items-center">
                              <Button color="danger" onClick={() => remove(index)}><i className='fa fa-trash'></i></Button>
                            </div>
                        </td>
                      </tr>
                    );
                  })}
            </tbody>
        </Table>
        <FormGroup className="text-right d-flex align-items-center justify-content-between">
            <Button color="success" onClick={addRow}>+ <Trans>Add a new line</Trans></Button>
            <Button type="submit" color='primary' onClick={handleSubmit(handleMasterSubmit)}><Trans>Submit</Trans></Button>
        </FormGroup>
        </FormProvider>
      </div>
    </Page>
  );
};

export default AddMasterFiles;
